<template>
  <v-container class="page admin-cursos" fluid>
    <configurar-curso-pregrabado
      v-if="cursoConfig"
      :nivel="cursoConfig"
      @volver="cursoConfig = null"
    />
    <header v-if="!cursoConfig" class="page-head">
      <div class="d-flex align-start">
        <div>
          <h1>{{ esAdmin ? "Administrar cursos" : "Cursos y videos" }}</h1>
          <p class="lead">
            Crea el curso para INBI o FAST. Al publicarlo, se activa en la app de esa escuela.
          </p>
        </div>
        <v-spacer></v-spacer>
        <v-btn v-if="privilegiado" text small class="text-capitalize" @click="dialogPermisos = true">
          Permisos
        </v-btn>
      </div>
    </header>

    <div v-if="!cursoConfig" class="tabs">
      <button type="button" :class="{ on: marca === '' }" @click="setFiltro('')">Todas</button>
      <button type="button" :class="{ on: marca === 'inbi' }" @click="setFiltro('inbi')">INBI</button>
      <button type="button" :class="{ on: marca === 'fast' }" @click="setFiltro('fast')">FAST</button>
    </div>

    <v-alert v-if="!cursoConfig && error" type="error" dismissible class="mb-4" @input="error = ''">{{ error }}</v-alert>
    <v-alert v-if="!cursoConfig && ok" type="success" dense dismissible class="mb-4" @input="ok = ''">{{ ok }}</v-alert>
    <v-alert v-if="!cursoConfig && sinAcceso" type="warning" dense>No tienes permiso para administrar este curso.</v-alert>

    <section v-if="esAdmin && !cursoConfig" class="panel form-panel">
      <div class="panel-head">
        <div class="panel-title">
          <span class="panel-ico"><v-icon color="#1d4ed8" size="22">mdi-file-document-edit-outline</v-icon></span>
          <div>
            <h2>Información del curso</h2>
            <p>Completa los datos para crear un curso en el catálogo.</p>
          </div>
        </div>
      </div>

      <div class="form-grid three">
        <v-select v-model="form.marca" :items="marcas" item-text="label" item-value="value" label="Marca" outlined dense hide-details prepend-inner-icon="mdi-tag-outline" />
        <v-select v-model="form.estado" :items="estados" item-text="label" item-value="value" label="Estado" outlined dense hide-details prepend-inner-icon="mdi-flag-outline" />
        <v-select v-model="form.subtitulo" :items="nivelesOpciones" item-text="label" item-value="value" label="Nivel" outlined dense hide-details prepend-inner-icon="mdi-stairs" />
      </div>

      <div class="form-grid">
        <v-text-field
          v-model="form.nombre"
          label="Nombre"
          hint="Ya viene Inglés Nivel ; solo agrega el número"
          persistent-hint
          counter="100"
          maxlength="100"
          outlined
          dense
          prepend-inner-icon="mdi-book-open-page-variant"
        />
      </div>

      <div class="form-grid">
        <v-textarea v-model="form.descripcion" label="Descripción" outlined dense rows="3" counter="500" maxlength="500" prepend-inner-icon="mdi-text" />
      </div>

      <div class="form-grid price">
        <v-text-field
          v-model.number="form.precio"
          label="Precio MXN"
          type="number"
          min="0"
          outlined
          dense
          hide-details
          prepend-inner-icon="mdi-currency-usd"
          :disabled="precioBloqueado"
        />
        <div class="price-actions">
          <button class="btn ghost" type="button" @click="precioBloqueado = false">Editar</button>
          <button class="btn primary" type="button" :disabled="precioBloqueado" @click="aceptarPrecio">Aceptar</button>
        </div>
      </div>

      <div class="form-actions">
        <button class="btn primary" type="button" :disabled="guardando" @click="crear">
          <v-icon left dark small>mdi-plus-circle-outline</v-icon>
          {{ guardando ? "Creando…" : "Crear curso" }}
        </button>
      </div>
    </section>

    <section v-if="!sinAcceso && !cursoConfig" class="panel list-panel">
      <div class="list-toolbar">
        <div class="panel-title">
          <span class="panel-ico"><v-icon color="#0f766e" size="22">mdi-view-grid-plus-outline</v-icon></span>
          <div>
            <h2>Cursos disponibles</h2>
            <p>{{ nivelesFiltrados.length }} curso{{ nivelesFiltrados.length === 1 ? "" : "s" }}</p>
          </div>
        </div>
        <div class="toolbar-right">
          <div class="search">
            <v-icon small color="#94a3b8">mdi-magnify</v-icon>
            <input v-model="busqueda" type="search" placeholder="Buscar curso..." />
          </div>
          <button type="button" class="tool-btn" title="Actualizar" :disabled="cargando" @click="cargar">
            <v-icon :class="{ spin: cargando }">mdi-refresh</v-icon>
          </button>
          <div class="view-toggle">
            <button type="button" :class="{ on: vista === 'cuadros' }" @click="vista = 'cuadros'">
              <v-icon small>mdi-view-grid-outline</v-icon>
            </button>
            <button type="button" :class="{ on: vista === 'lista' }" @click="vista = 'lista'">
              <v-icon small>mdi-view-list-outline</v-icon>
            </button>
          </div>
        </div>
      </div>

      <v-progress-linear v-if="cargando" indeterminate class="mb-3" />
      <p v-if="!cargando && !nivelesFiltrados.length" class="empty">No hay cursos con ese filtro.</p>

      <div :class="vista === 'lista' ? 'courses-list' : 'courses-grid'">
        <article v-for="(n, idx) in nivelesFiltrados" :key="n.id" class="course-card" :class="[vista, accentClass(idx)]">
          <div class="accent" />
          <div class="course-body">
            <div class="course-top">
              <span class="brand-tag" :class="n.marca">{{ n.marca }}</span>
              <span class="estado" :class="n.estado">{{ n.estado === "publicado" ? "publicado" : "próximamente" }}</span>
            </div>

            <template v-if="editando && editando.id === n.id">
              <div class="edit-box">
                <v-text-field v-model="editando.nombre" label="Nombre" outlined dense hide-details class="mb-2" />
                <v-select v-model="editando.subtitulo" :items="nivelesOpciones" item-text="label" item-value="value" label="Nivel" outlined dense hide-details class="mb-2" />
                <v-textarea v-model="editando.descripcion" label="Descripción" outlined dense rows="3" hide-details class="mb-2" />
                <div class="edit-actions">
                  <button class="btn primary" type="button" :disabled="guardandoEdit" @click="guardarEdicion">
                    {{ guardandoEdit ? "Guardando…" : "Guardar" }}
                  </button>
                  <button class="btn ghost" type="button" @click="editando = null">Cancelar</button>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="course-main">
                <div class="book-ico" :class="accentClass(idx)">
                  <v-icon size="28">mdi-book-open-variant</v-icon>
                </div>
                <div class="course-copy">
                  <h3>{{ n.nombre }}</h3>
                  <p class="sub">{{ n.subtitulo }}</p>
                </div>
              </div>
            </template>

            <div v-if="!(editando && editando.id === n.id)" class="course-actions" :class="{ admin: esAdmin }">
              <div class="action-slot">
                <button type="button" class="btn-config" @click="abrirConfig(n)">
                  <v-icon x-small>mdi-play-circle-outline</v-icon>
                  <span>Configurar<br />curso</span>
                </button>
              </div>
              <div v-if="esAdmin" class="action-slot">
                <v-menu offset-y left min-width="220">
                  <template v-slot:activator="{ on, attrs }">
                    <button type="button" class="btn-outline" v-bind="attrs" v-on="on">
                      Acciones
                      <v-icon x-small>mdi-dots-vertical</v-icon>
                    </button>
                  </template>
                  <div class="acciones-menu">
                    <button type="button" @click="abrirEdicion(n)">
                      <v-icon small left>mdi-pencil-outline</v-icon>
                      Editar
                    </button>
                    <button type="button" @click="toggleEstado(n)">
                      <v-icon small left>{{ n.estado === "publicado" ? "mdi-eye-off-outline" : "mdi-earth" }}</v-icon>
                      {{ n.estado === "publicado" ? "Pasar a próximamente" : "Publicar" }}
                    </button>
                  </div>
                </v-menu>
              </div>
              <div v-if="esAdmin" class="action-slot">
                <button class="btn-danger" type="button" @click="pedirEliminar(n)">
                  <v-icon x-small>mdi-trash-can-outline</v-icon>
                  Eliminar
                </button>
              </div>
            </div>
          </div>
        </article>
      </div>
    </section>

    <div v-if="confirmDialog" class="confirm-overlay" @click.self="confirmDialog = null">
      <div class="confirm-card">
        <p class="confirm-eyebrow">{{ confirmDialog.eyebrow }}</p>
        <h3>{{ confirmDialog.titulo }}</h3>
        <p class="confirm-body">{{ confirmDialog.cuerpo }}</p>
        <div class="confirm-actions">
          <button class="btn ghost" type="button" @click="confirmDialog = null">Cancelar</button>
          <button class="btn primary" :class="confirmDialog.peligro ? 'danger' : ''" type="button" @click="aceptarConfirm">
            {{ confirmDialog.aceptar }}
          </button>
        </div>
      </div>
    </div>

    <v-dialog v-model="dialogPermisos" max-width="640">
      <v-card class="pa-4">
        <div class="text-h6 mb-3">Permisos</div>
        <v-autocomplete v-model="permiso.iddepartamento" :items="departamentos" item-text="departamento" item-value="iddepartamento" label="Departamento" outlined dense @change="filtrarPersonas" />
        <v-autocomplete v-model="permiso.iderp" :items="personas" item-text="nombre_completo" item-value="iderp" label="Persona" outlined dense />
        <v-select v-model="permiso.rol" :items="roles" label="Permiso" outlined dense />
        <v-btn small color="primary" class="text-capitalize mb-4" @click="guardarPermiso">Guardar</v-btn>
        <div v-for="p in permisos" :key="p.id" class="d-flex align-center mb-2">
          <span>{{ p.nombre }} · {{ p.rol === 'admin' ? 'Admin' : 'Auxiliar' }}</span>
          <v-spacer />
          <v-btn icon small @click="quitarPermiso(p)"><v-icon small>mdi-delete</v-icon></v-btn>
        </div>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ConfigurarCursoPregrabado from "./ConfigurarCursoPregrabado.vue"

const NOMBRE_BASE = "Inglés Nivel "
const NIVELES_OPCIONES = [
  { label: "Desde cero", value: "Desde cero" },
  { label: "Ritmo ágil", value: "Ritmo ágil" },
  { label: "Camino completo", value: "Camino completo" },
]

function formVacio(marca) {
  return {
    marca: marca || "inbi",
    nombre: NOMBRE_BASE,
    subtitulo: "Desde cero",
    descripcion: "",
    precio: 599,
    estado: "proximamente",
  }
}

function mensaje(e, texto) {
  if (e && e.body && e.body.message) return e.body.message
  if (e && e.response && e.response.data && e.response.data.message) return e.response.data.message
  return texto
}

export default {
  components: { ConfigurarCursoPregrabado },
  data() {
    return {
      esAdmin: false,
      privilegiado: false,
      sinAcceso: false,
      marca: "",
      niveles: [],
      busqueda: "",
      vista: "cuadros",
      cargando: false,
      guardando: false,
      guardandoEdit: false,
      editando: null,
      confirmDialog: null,
      error: "",
      ok: "",
      precioBloqueado: true,
      form: formVacio("inbi"),
      marcas: [
        { label: "INBI", value: "inbi" },
        { label: "FAST", value: "fast" },
      ],
      estados: [
        { label: "Publicado", value: "publicado" },
        { label: "Próximamente", value: "proximamente" },
      ],
      nivelesOpciones: NIVELES_OPCIONES,
      cursoConfig: null,
      dialogPermisos: false,
      departamentos: [],
      personasTodas: [],
      puestos: [],
      personas: [],
      permisos: [],
      permiso: { iddepartamento: null, iderp: null, rol: "admin_recursos" },
      roles: [
        { text: "Admin", value: "admin" },
        { text: "Auxiliar", value: "admin_recursos" },
      ],
    }
  },
  computed: {
    nivelesFiltrados() {
      const q = this.busqueda.trim().toLowerCase()
      if (!q) return this.niveles
      return this.niveles.filter((n) => {
        const blob = (n.nombre + " " + (n.subtitulo || "") + " " + n.marca + " " + (n.descripcion || "")).toLowerCase()
        return blob.indexOf(q) >= 0
      })
    },
  },
  created() {
    this.cargarAcceso()
  },
  watch: {
    dialogPermisos(v) {
      if (v) this.cargarPermisos()
    },
  },
  methods: {
    accentClass(idx) {
      return "accent-" + ((idx % 3) + 1)
    },
    setFiltro(valor) {
      this.marca = valor
      if (valor === "inbi" || valor === "fast") this.form.marca = valor
      this.cargar()
    },
    cargarAcceso() {
      this.$http.get("curso.virtual.acceso").then((r) => {
        const data = r.data || r.body || {}
        this.esAdmin = data.rol === "admin"
        this.privilegiado = !!data.privilegiado
        this.sinAcceso = !data.rol
        if (data.rol) {
          this.cargar()
          this.cargarPrecio()
        }
      }).catch((e) => {
        this.error = mensaje(e, "No se pudo validar el acceso")
      })
    },
    cargarPrecio() {
      this.$http.get("curso.virtual.precio").then((r) => {
        const data = r.data || r.body || {}
        const monto = Number(data.monto)
        if (Number.isFinite(monto)) this.form.precio = monto
      }).catch(() => {})
    },
    aceptarPrecio() {
      this.$http.put("curso.virtual.precio", { monto: this.form.precio }).then(() => {
        this.precioBloqueado = true
        this.ok = "Precio general actualizado. Los pagos ya registrados no cambian."
      }).catch((e) => {
        this.error = mensaje(e, "No se pudo guardar el precio")
      })
    },
    cargar() {
      this.cargando = true
      this.error = ""
      const opts = this.marca ? { params: { marca: this.marca } } : {}
      this.$http.get("curso.virtual.niveles", opts).then((r) => {
        const data = r.data || r.body || {}
        this.niveles = data.niveles || []
      }).catch((e) => {
        this.error = mensaje(e, "No se pudo cargar el panel")
      }).finally(() => {
        this.cargando = false
      })
    },
    crear() {
      this.error = ""
      this.ok = ""
      const nombre = String(this.form.nombre || "").trim()
      if (!nombre || nombre === NOMBRE_BASE.trim()) {
        this.error = "Agrega el número al nombre (ej. Inglés Nivel 4)"
        return
      }
      this.guardando = true
      this.$http.post("curso.virtual.niveles", {
        marca: this.form.marca,
        nombre: nombre,
        subtitulo: this.form.subtitulo || "Desde cero",
        descripcion: String(this.form.descripcion || "").trim(),
        estado: this.form.estado,
      }).then((r) => {
        const data = r.data || r.body || {}
        const nivel = data.nivel || {}
        const escuela = this.form.marca === "fast" ? "FAST" : "INBI"
        this.ok = this.form.estado === "publicado"
          ? "Curso creado y activo en la app " + escuela
          : "Curso creado: " + (nivel.nombre || nombre) + ". Está en próximamente hasta que lo publiques."
        this.form = formVacio(this.marca === "fast" || this.marca === "inbi" ? this.marca : this.form.marca)
        this.cargarPrecio()
        this.cargar()
      }).catch((e) => {
        this.error = mensaje(e, "No se pudo crear el curso")
      }).finally(() => {
        this.guardando = false
      })
    },
    abrirEdicion(n) {
      const prefijo = n.subtitulo_prefijo || String(n.subtitulo || "").split("·")[0].trim()
      const match = NIVELES_OPCIONES.find((o) => o.value === prefijo)
      this.editando = {
        id: n.id,
        nombre: n.nombre || "",
        subtitulo: match ? match.value : "Desde cero",
        descripcion: n.descripcion || "",
      }
    },
    guardarEdicion() {
      if (!this.editando) return
      const nombre = String(this.editando.nombre || "").trim()
      if (!nombre) {
        this.error = "El nombre no puede quedar vacío"
        return
      }
      this.guardandoEdit = true
      this.$http.put("curso.virtual.niveles/" + this.editando.id, {
        nombre: nombre,
        subtitulo: this.editando.subtitulo || "Desde cero",
        descripcion: String(this.editando.descripcion || "").trim(),
      }).then((r) => {
        const data = r.data || r.body || {}
        const idx = this.niveles.findIndex((x) => x.id === this.editando.id)
        if (idx >= 0 && data.nivel) this.$set(this.niveles, idx, data.nivel)
        else this.cargar()
        this.ok = "Tarjeta actualizada"
        this.editando = null
      }).catch((e) => {
        this.error = mensaje(e, "No se pudo guardar")
      }).finally(() => {
        this.guardandoEdit = false
      })
    },
    toggleEstado(n) {
      const siguiente = n.estado === "publicado" ? "proximamente" : "publicado"
      const escuela = n.marca === "fast" ? "FAST" : "INBI"
      this.confirmDialog = {
        tipo: "estado",
        nivel: n,
        siguiente: siguiente,
        eyebrow: String(n.marca || "").toUpperCase(),
        titulo: siguiente === "publicado" ? "¿Publicar “" + n.nombre + "”?" : "¿Pasar “" + n.nombre + "” a próximamente?",
        cuerpo: siguiente === "publicado"
          ? "Quedará activo en la app " + escuela + "."
          : "Dejará de verse en la app " + escuela + " hasta que lo publiques de nuevo.",
        aceptar: siguiente === "publicado" ? "Publicar" : "Confirmar",
        peligro: false,
      }
    },
    pedirEliminar(n) {
      this.confirmDialog = {
        tipo: "eliminar",
        nivel: n,
        eyebrow: "Eliminar curso",
        titulo: "¿Eliminar “" + n.nombre + "”?",
        cuerpo: "Se borrarán sus lecciones y videos. Esta acción no se puede deshacer.",
        aceptar: "Eliminar",
        peligro: true,
      }
    },
    aceptarConfirm() {
      if (!this.confirmDialog) return
      const n = this.confirmDialog.nivel
      if (this.confirmDialog.tipo === "estado") {
        this.$http.put("curso.virtual.niveles/" + n.id, { estado: this.confirmDialog.siguiente }).then((r) => {
          const data = r.data || r.body || {}
          const idx = this.niveles.findIndex((x) => x.id === n.id)
          if (idx >= 0 && data.nivel) this.$set(this.niveles, idx, data.nivel)
          else this.cargar()
          const escuela = n.marca === "fast" ? "FAST" : "INBI"
          this.ok = this.confirmDialog.siguiente === "publicado"
            ? n.nombre + " ya está activo en " + escuela
            : n.nombre + " pasó a próximamente"
          this.confirmDialog = null
        }).catch((e) => {
          this.error = mensaje(e, "No se pudo cambiar el estado")
        })
        return
      }
      this.$http.delete("curso.virtual.niveles/" + n.id).then(() => {
        this.ok = "Curso eliminado"
        this.confirmDialog = null
        this.cargar()
      }).catch((e) => {
        this.error = mensaje(e, "No se pudo eliminar")
      })
    },
    abrirConfig(n) {
      this.cursoConfig = n
    },
    cargarPermisos() {
      this.$http.get("departamentos.activos").then((r) => { this.departamentos = r.data || [] }).catch(() => {})
      this.$http.get("puestos.all").then((r) => { this.puestos = r.data || [] }).catch(() => {})
      this.$http.get("usuarios.activos").then((r) => {
        this.personasTodas = r.data || []
        this.filtrarPersonas()
      }).catch(() => {})
      this.$http.get("curso.virtual.permisos").then((r) => {
        const data = r.data || r.body || {}
        this.permisos = data.permisos || []
      }).catch(() => {})
    },
    filtrarPersonas() {
      const depto = this.permiso.iddepartamento
      if (!depto) {
        this.personas = this.personasTodas
        return
      }
      const puestos = this.puestos.filter((p) => Number(p.iddepartamento) === Number(depto))
      const ids = puestos.map((p) => Number(p.idpuesto))
      this.personas = this.personasTodas.filter((u) => ids.indexOf(Number(u.idpuesto || u.id_puesto)) >= 0)
    },
    guardarPermiso() {
      const persona = this.personasTodas.find((u) => Number(u.iderp) === Number(this.permiso.iderp))
      const depto = this.departamentos.find((d) => Number(d.iddepartamento) === Number(this.permiso.iddepartamento))
      if (!persona) {
        this.error = "Selecciona a la persona"
        return
      }
      this.$http.post("curso.virtual.permisos", {
        iderp: persona.iderp,
        nombre: persona.nombre_completo,
        iddepartamento: this.permiso.iddepartamento,
        departamento: depto ? depto.departamento : "",
        rol: this.permiso.rol,
      }).then(() => {
        this.ok = "Permiso guardado"
        this.cargarPermisos()
      }).catch((e) => {
        this.error = mensaje(e, "No se pudo guardar el permiso")
      })
    },
    quitarPermiso(item) {
      this.$http.delete("curso.virtual.permisos/" + item.id).then(() => this.cargarPermisos()).catch(() => {})
    },
  },
}
</script>

<style scoped>
.admin-cursos { max-width: 1180px; background: #f8fafc; }
.page-head h1 { font-weight: 800; letter-spacing: -0.03em; margin: 0 0 8px; color: #0f172a; font-size: 32px; }
.lead { color: #64748b; margin: 0 0 18px; }
.tabs { display: flex; gap: 8px; margin-bottom: 22px; }
.tabs button { border: 0; background: #e2e8f0; border-radius: 999px; padding: 8px 14px; font-weight: 700; cursor: pointer; font-family: inherit; }
.tabs button.on { background: #0f172a; color: #fff; }
.panel { background: #fff; border: 1px solid rgba(226, 232, 240, 0.9); border-radius: 20px; box-shadow: 0 14px 40px rgba(15, 23, 42, 0.06); padding: 22px; margin-bottom: 22px; }
.panel-head { margin-bottom: 18px; }
.panel-title { display: flex; align-items: flex-start; gap: 12px; }
.panel-ico { width: 40px; height: 40px; border-radius: 12px; background: #eff6ff; display: grid; place-items: center; flex-shrink: 0; }
.list-panel .panel-ico { background: #ecfdf5; }
.panel-title h2 { margin: 0; font-size: 18px; font-weight: 800; color: #0f172a; }
.panel-title p { margin: 2px 0 0; font-size: 13px; color: #64748b; }
.form-grid { margin-bottom: 16px; }
.form-grid.three { display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px; }
.form-grid.price { max-width: 280px; }
.price-actions { display: flex; gap: 8px; margin-top: 10px; }
.price-actions .btn { margin-top: 0; padding: 8px 16px; }
.form-actions { margin-top: 16px; }
.btn { display: inline-flex; align-items: center; justify-content: center; gap: 6px; border: 0; border-radius: 999px; padding: 10px 18px; font-weight: 700; cursor: pointer; font-family: inherit; }
.btn.primary { background: #0f172a; color: #fff; }
.btn.ghost { background: #e2e8f0; color: #0f172a; }
.btn.danger { background: #b91c1c; color: #fff; }
.btn:disabled { opacity: 0.55; cursor: default; }
.list-toolbar { display: flex; align-items: center; justify-content: space-between; gap: 16px; flex-wrap: wrap; margin-bottom: 16px; }
.toolbar-right { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.search { display: flex; align-items: center; gap: 8px; background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 999px; padding: 8px 14px; min-width: 220px; }
.search input { border: 0; outline: 0; background: transparent; width: 180px; font: inherit; font-size: 14px; }
.tool-btn { width: 40px; height: 40px; border: 1px solid #e2e8f0; background: #fff; border-radius: 12px; cursor: pointer; }
.spin { animation: spin 0.8s linear infinite; }
@keyframes spin { to { transform: rotate(360deg); } }
.view-toggle { display: inline-flex; border: 1px solid #e2e8f0; border-radius: 12px; overflow: hidden; background: #f8fafc; }
.view-toggle button { width: 40px; height: 40px; border: 0; background: transparent; color: #94a3b8; cursor: pointer; }
.view-toggle button.on { background: #dbeafe; color: #2563eb; }
.empty { color: #94a3b8; text-align: center; padding: 28px 10px; }
.courses-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); gap: 14px; }
.courses-list { display: flex; flex-direction: column; gap: 12px; }
.course-card { position: relative; display: flex; background: #fff; border: 1px solid #e8eef5; border-radius: 16px; overflow: hidden; }
.course-card:hover { box-shadow: 0 12px 28px rgba(15, 23, 42, 0.08); }
.accent { width: 5px; flex-shrink: 0; }
.course-card.accent-1 .accent { background: #a7f3d0; }
.course-card.accent-2 .accent { background: #bfdbfe; }
.course-card.accent-3 .accent { background: #ddd6fe; }
.course-body { flex: 1; padding: 16px 16px 14px; display: flex; flex-direction: column; min-width: 0; }
.course-top { display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px; }
.brand-tag { text-transform: uppercase; font-size: 11px; font-weight: 800; letter-spacing: 0.08em; }
.brand-tag.inbi { color: #0e7c78; }
.brand-tag.fast { color: #1a2a7a; }
.estado { font-size: 11px; font-weight: 700; text-transform: uppercase; padding: 4px 10px; border-radius: 999px; background: #f1f5f9; color: #64748b; }
.estado.publicado { background: #dcfce7; color: #166534; }
.estado.proximamente { background: #fef3c7; color: #92400e; }
.course-main { display: flex; gap: 14px; margin-bottom: 14px; }
.book-ico { width: 52px; height: 52px; border-radius: 14px; display: grid; place-items: center; }
.book-ico.accent-1 { background: #d1fae5; color: #059669; }
.book-ico.accent-2 { background: #dbeafe; color: #2563eb; }
.book-ico.accent-3 { background: #ede9fe; color: #7c3aed; }
.course-copy h3 { margin: 0 0 4px; font-size: 18px; font-weight: 800; color: #0f172a; }
.sub { margin: 0 0 6px; color: #64748b; font-size: 13px; }
.price { margin: 0; font-weight: 800; color: #334155; }
.course-actions { margin-top: auto; display: flex; gap: 10px; padding-top: 12px; border-top: 1px solid #f1f5f9; }
.action-slot { flex: 1; min-width: 0; }
.btn-config, .btn-outline, .btn-danger { width: 100%; min-height: 52px; border-radius: 12px; font-weight: 700; font-size: 12px; cursor: pointer; font-family: inherit; }
.btn-config { display: flex; flex-direction: column; align-items: center; justify-content: center; color: #1d4ed8; background: #eff6ff; border: 1px solid #dbeafe; }
.btn-outline { display: flex; align-items: center; justify-content: center; gap: 4px; border: 1px solid #e2e8f0; background: #fff; color: #334155; }
.btn-danger { display: flex; align-items: center; justify-content: center; gap: 4px; border: 1px solid #fecaca; background: #fff; color: #b91c1c; }
.acciones-menu { background: #fff; padding: 6px; }
.acciones-menu button { display: flex; align-items: center; width: 100%; border: 0; background: transparent; text-align: left; padding: 10px 12px; border-radius: 10px; font-weight: 600; cursor: pointer; }
.acciones-menu button:hover { background: #f1f5f9; }
.confirm-overlay { position: fixed; inset: 0; z-index: 2000; display: flex; align-items: center; justify-content: center; background: rgba(15, 23, 42, 0.42); }
.confirm-card { width: min(420px, 100%); padding: 28px 24px 22px; background: #fff; border-radius: 20px; }
.confirm-eyebrow { margin: 0 0 8px; font-size: 11px; font-weight: 700; letter-spacing: 0.12em; text-transform: uppercase; color: #64748b; }
.confirm-card h3 { margin: 0 0 10px; font-size: 22px; color: #0f172a; }
.confirm-body { margin: 0 0 22px; color: #64748b; }
.confirm-actions { display: flex; justify-content: flex-end; gap: 10px; }
.leccion-row { display: grid; grid-template-columns: 1fr 220px; gap: 12px; align-items: center; margin-top: 12px; }
.course-card.lista .course-body { display: grid; grid-template-columns: minmax(0, 1fr) auto; grid-template-areas: "top top" "main actions" "edit edit"; align-items: center; }
.course-card.lista .course-top { grid-area: top; }
.course-card.lista .course-main { grid-area: main; margin-bottom: 0; }
.course-card.lista .edit-box { grid-area: edit; }
.course-card.lista .course-actions { grid-area: actions; border-top: 0; padding-top: 0; min-width: 280px; }
@media (max-width: 900px) {
  .form-grid.three { grid-template-columns: 1fr; }
}
</style>
